<div class="dash-layout">

  <!-- ========== SIDEBAR ========== -->
  <aside class="sidebar" [class.open]="sidebarOpen">

    <div class="sidebar-brand">
      <img src="assets/logo-clinixcore-light.svg" alt="ClinixCore" class="brand-logo">
      <p class="brand-slogan">O núcleo da sua prática clínica</p>
    </div>

    <nav class="sidebar-nav">
      <a class="nav-item" [class.active]="router.url === '/dashboard'" (click)="navigate('/dashboard')">
        <i class="bi bi-speedometer2"></i><span>Dashboard</span>
      </a>
      <a class="nav-item" *ngIf="canManageProfessionals"
         [class.active]="router.url === '/professionals'" (click)="navigate('/professionals')">
        <i class="bi bi-person-badge"></i><span>Profissionais</span>
      </a>
      <a class="nav-item" [class.active]="router.url === '/agenda'" (click)="navigate('/agenda')">
        <i class="bi bi-calendar-event"></i><span>Agenda</span>
      </a>
      <a class="nav-item" [class.active]="router.url === '/patients'" (click)="navigate('/patients')">
        <i class="bi bi-people"></i><span>Pacientes</span>
      </a>
      <a class="nav-item" [class.active]="router.url === '/medical-records'" (click)="navigate('/medical-records')">
        <i class="bi bi-clipboard2-pulse"></i><span>Prontuários</span>
      </a>

      <!-- Menu Financeiro Expansível -->
      <a class="nav-item nav-item-expandable"
         [class.active]="isFinancialRoute()"
         [class.expanded]="financialMenuOpen"
         (click)="toggleFinancialMenu()">
        <i class="bi bi-cash-coin"></i>
        <span>Financeiro</span>
        <i class="bi bi-chevron-down nav-arrow"></i>
      </a>
      <div class="nav-submenu" *ngIf="financialMenuOpen">
        <a class="nav-subitem" [class.active]="router.url === '/suppliers'" (click)="navigate('/suppliers')">
          <i class="bi bi-building"></i><span>Fornecedores</span>
        </a>
        <a class="nav-subitem" [class.active]="router.url === '/account-categories'" (click)="navigate('/account-categories')">
          <i class="bi bi-tags"></i><span>Categorias</span>
        </a>
        <a class="nav-subitem" [class.active]="router.url === '/cost-centers'" (click)="navigate('/cost-centers')">
          <i class="bi bi-diagram-3"></i><span>Centros de Custo</span>
        </a>
        <a class="nav-subitem" [class.active]="router.url === '/bank-accounts'" (click)="navigate('/bank-accounts')">
          <i class="bi bi-bank"></i><span>Contas Bancárias</span>
        </a>
        <a class="nav-subitem" [class.active]="router.url === '/health-insurances'" (click)="navigate('/health-insurances')">
          <i class="bi bi-heart-pulse"></i><span>Convênios</span>
        </a>
        <a class="nav-subitem" [class.active]="router.url === '/accounts-receivable'" (click)="navigate('/accounts-receivable')">
          <i class="bi bi-arrow-down-circle"></i><span>Contas a Receber</span>
        </a>
        <a class="nav-subitem" [class.active]="router.url === '/accounts-payable'" (click)="navigate('/accounts-payable')">
          <i class="bi bi-arrow-up-circle"></i><span>Contas a Pagar</span>
        </a>
      </div>
    </nav>

    <!-- Lista de profissionais no sidebar (oculta para profissional único dono) -->
    <div class="sidebar-profs" *ngIf="canSwitchProfessional || canManageProfessionals">
      <div class="sidebar-profs-header">
        <span>Profissionais</span>
        <button class="btn-add-mini" *ngIf="canManageProfessionals"
                (click)="openModal()" title="Novo profissional">
          <i class="bi bi-plus-lg"></i>
        </button>
      </div>

      <div class="text-center py-3" *ngIf="loadingProfessionals">
        <div class="spinner-border spinner-border-sm text-light opacity-50"></div>
      </div>

      <div *ngIf="!loadingProfessionals">
        <div class="no-profs" *ngIf="professionals.length === 0">
          <p>Nenhum profissional ainda</p>
          <button class="btn btn-sm btn-outline-light w-100" (click)="openModal()">
            <i class="bi bi-plus-lg me-1"></i> Cadastrar agora
          </button>
        </div>

        <div class="prof-item"
             *ngFor="let p of professionals"
             [class.selected]="selectedProfessional?.id === p.id"
             (click)="selectProfessional(p)">
          <div class="prof-avatar-xs">{{ p.name.substring(0,2).toUpperCase() }}</div>
          <div class="prof-item-info">
            <div class="prof-item-name">{{ p.name }}</div>
            <div class="prof-item-spec">{{ p.specialty || 'Geral' }}</div>
          </div>
          <span class="online-dot" [class.on]="p.isActive"></span>
        </div>
      </div>
    </div>

    <!-- Rodapé sidebar -->
    <div class="sidebar-footer">
      <div class="sidebar-user">
        <div class="user-ava">{{ user?.name?.substring(0,2).toUpperCase() }}</div>
        <div class="user-meta">
          <div class="user-name">{{ user?.name }}</div>
          <div class="user-email">{{ user?.email }}</div>
        </div>
      </div>
      <button class="btn-logout" (click)="openMyProfile()" title="Meu Cadastro" style="margin-right: 8px;">
        <i class="bi bi-gear"></i>
      </button>
      <button class="btn-logout" (click)="logout()" title="Sair">
        <i class="bi bi-box-arrow-right"></i>
      </button>
    </div>
  </aside>

  <!-- Overlay sidebar mobile -->
  <div class="sidebar-backdrop" *ngIf="sidebarOpen" (click)="sidebarOpen = false"></div>

  <!-- ========== CONTEÚDO PRINCIPAL ========== -->
  <main class="main">

    <!-- Topbar -->
    <header class="topbar">
      <button class="btn-menu d-lg-none" (click)="sidebarOpen = !sidebarOpen">
        <i class="bi bi-list fs-4"></i>
      </button>

      <div class="topbar-info">
        <ng-container *ngIf="selectedProfessional">

          <!-- Switcher com dropdown — aparece quando pode trocar de profissional -->
          <div class="prof-switcher" *ngIf="canSwitchProfessional"
               (click)="showProfSwitcher = !showProfSwitcher"
               [class.open]="showProfSwitcher">
            <span class="topbar-prof-name">{{ selectedProfessional.name }}</span>
            <i class="bi bi-chevron-down switcher-arrow"></i>

            <div class="prof-switcher-dropdown" *ngIf="showProfSwitcher"
                 (click)="$event.stopPropagation()">
              <div class="prof-switch-item"
                   *ngFor="let p of professionals"
                   [class.current]="selectedProfessional?.id === p.id"
                   (click)="switchProfessional(p)">
                <div class="prof-switch-avatar">{{ p.name.substring(0,2).toUpperCase() }}</div>
                <div class="prof-switch-info">
                  <div class="prof-switch-name">{{ p.name }}</div>
                  <div class="prof-switch-spec">{{ p.specialty || 'Geral' }}</div>
                </div>
                <i class="bi bi-check-lg prof-switch-check"
                   *ngIf="selectedProfessional?.id === p.id"></i>
              </div>
            </div>
          </div>

          <!-- Nome estático quando não pode trocar de profissional -->
          <span class="topbar-prof-name" *ngIf="!canSwitchProfessional">
            {{ selectedProfessional.name }}
          </span>

          <span [class]="subClass(selectedProfessional?.subscription?.status)" class="ms-2 fs-sm">
            {{ subLabel(selectedProfessional?.subscription?.status) }}
          </span>
          <span class="badge bg-warning text-dark ms-1"
                *ngIf="selectedProfessional?.subscription?.status === 1">
            {{ daysRemaining(selectedProfessional?.subscription?.trialEndDate) }}d restantes
          </span>
        </ng-container>
        <span class="topbar-greeting" *ngIf="!selectedProfessional && !loadingProfessionals">
          {{ greeting() }}, <strong>{{ user?.name?.split(' ')[0] }}</strong>
        </span>
      </div>

      <!-- Overlay invisível para fechar o dropdown ao clicar fora -->
      <div class="prof-switcher-backdrop" *ngIf="showProfSwitcher"
           (click)="showProfSwitcher = false"></div>

      <div class="topbar-right">
        <span class="d-none d-md-block text-muted me-3">
          {{ greeting() }}, <strong>{{ user?.name?.split(' ')[0] }}</strong>
        </span>
      </div>
    </header>
    <div class="page-body">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<!-- ==============================================================
     MODAL — CADASTRO DE PROFISSIONAL
     ============================================================== -->
<div class="modal-overlay" *ngIf="showModal && router.url !== '/professionals'" (click)="closeModal()"></div>
<div class="modal-wrap"    *ngIf="showModal && router.url !== '/professionals'">
  <div class="modal-box">

    <!-- Header -->
    <div class="modal-box-header">
      <div>
        <h5 class="mb-0">Cadastrar Profissional</h5>
        <small class="text-muted">🎉 30 dias grátis · R$ 39,90/mês após o trial</small>
      </div>
      <button class="btn-x" (click)="closeModal()">✕</button>
    </div>

    <!-- Abas -->
    <div class="modal-tabs">
      <button class="modal-tab" [class.active]="modalTab === 'dados'"
              (click)="modalTab = 'dados'">
        <i class="bi bi-person-badge"></i> Dados
      </button>
      <button class="modal-tab" [class.active]="modalTab === 'pagamento'"
              (click)="modalTab = 'pagamento'">
        <i class="bi bi-credit-card"></i> Pagamento
        <span class="dot-warn" *ngIf="!billingForm.isConfigured"></span>
      </button>
    </div>

    <div class="modal-box-body">

      <!-- ====== ABA DADOS ====== -->
      <div *ngIf="modalTab === 'dados'">
        <div class="row g-3">
          <div class="col-12">
            <label class="form-label">Nome Completo *</label>
            <input type="text" class="form-control form-control-lg"
                   [(ngModel)]="profForm.name" placeholder="Dr. João Silva">
          </div>
          <div class="col-md-6">
            <label class="form-label">Especialidade</label>
            <select class="form-select" [(ngModel)]="profForm.specialty">
              <option value="">Selecione...</option>
              <option>Cardiologista</option><option>Clínico Geral</option>
              <option>Dermatologista</option><option>Dentista</option>
              <option>Fisioterapeuta</option><option>Ginecologista</option>
              <option>Nutricionista</option><option>Ortopedista</option>
              <option>Pediatra</option><option>Personal Trainer</option>
              <option>Psicólogo</option><option>Psiquiatra</option>
              <option>Terapeuta</option><option>Outro</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Nº Registro (CRM, CRP...)</label>
            <input type="text" class="form-control" [(ngModel)]="profForm.professionalId"
                   placeholder="CRM 12345-SP">
          </div>
          <div class="col-md-6">
            <label class="form-label">E-mail</label>
            <input type="email" class="form-control" [(ngModel)]="profForm.email"
                   placeholder="profissional@email.com">
          </div>
          <div class="col-md-6">
            <label class="form-label">Telefone</label>
            <input type="tel" class="form-control" [(ngModel)]="profForm.phone"
                   (input)="onProfPhoneInput($event)"
                   placeholder="(11) 98765-4321" maxlength="15">
          </div>
          <div class="col-md-8">
            <label class="form-label">Endereço</label>
            <input type="text" class="form-control" [(ngModel)]="profForm.address"
                   placeholder="Rua, Avenida, etc">
          </div>
          <div class="col-md-4">
            <label class="form-label">Número</label>
            <input type="text" class="form-control" [(ngModel)]="profForm.number"
                   placeholder="123">
          </div>
          <div class="col-md-6">
            <label class="form-label">Bairro</label>
            <input type="text" class="form-control" [(ngModel)]="profForm.neighborhood"
                   placeholder="Centro">
          </div>
          <div class="col-md-6">
            <label class="form-label">Complemento</label>
            <input type="text" class="form-control" [(ngModel)]="profForm.complement"
                   placeholder="Apto 101, Sala 5, etc">
          </div>
          <div class="col-md-5">
            <label class="form-label">Cidade</label>
            <input type="text" class="form-control" [(ngModel)]="profForm.city"
                   placeholder="São Paulo">
          </div>
          <div class="col-md-3">
            <label class="form-label">Estado (UF)</label>
            <input type="text" class="form-control" [(ngModel)]="profForm.state"
                   placeholder="SP" maxlength="2">
          </div>
          <div class="col-md-4">
            <label class="form-label">CEP</label>
            <input type="text" class="form-control" [(ngModel)]="profForm.zipCode"
                   placeholder="12345-678">
          </div>
          <div class="col-12">
            <label class="form-label">Observações</label>
            <textarea class="form-control" rows="2" [(ngModel)]="profForm.notes"></textarea>
          </div>
        </div>
      </div>

      <!-- ====== ABA PAGAMENTO ====== -->
      <div *ngIf="modalTab === 'pagamento'">
        <p class="text-muted mb-4">
          Configure a forma de pagamento para a assinatura de
          <strong>R$ 39,90/mês</strong> (cobrado após os 30 dias de trial).
        </p>

        <div class="method-picker mb-4">
          <div class="method-opt" [class.sel]="billingForm.preferredPaymentMethod === 1"
               (click)="billingForm.preferredPaymentMethod = 1">
            <span class="method-ico">📱</span>
            <div>
              <strong>PIX</strong>
              <small>Cobrança mensal por PIX</small>
            </div>
            <i class="bi bi-check-circle-fill chk"></i>
          </div>
          <div class="method-opt" [class.sel]="billingForm.preferredPaymentMethod === 2"
               (click)="billingForm.preferredPaymentMethod = 2">
            <span class="method-ico">💳</span>
            <div>
              <strong>Cartão de Crédito</strong>
              <small>Débito automático mensal</small>
            </div>
            <i class="bi bi-check-circle-fill chk"></i>
          </div>
        </div>

        <!-- Formulário PIX -->
        <div *ngIf="billingForm.preferredPaymentMethod === 1">
          <div class="row g-3">
            <div class="col-md-5">
              <label class="form-label">Tipo de Chave</label>
              <select class="form-select" [(ngModel)]="billingForm.pixKeyType">
                <option [ngValue]="3">E-mail</option>
                <option [ngValue]="1">CPF</option>
                <option [ngValue]="2">CNPJ</option>
                <option [ngValue]="4">Telefone</option>
                <option [ngValue]="5">Chave Aleatória</option>
              </select>
            </div>
            <div class="col-md-7">
              <label class="form-label">Chave PIX</label>
              <input type="text" class="form-control" [(ngModel)]="billingForm.pixKey"
                     [placeholder]="pixPlaceholder()">
            </div>
            <div class="col-12">
              <label class="form-label">Nome do Titular</label>
              <input type="text" class="form-control" [(ngModel)]="billingForm.pixHolderName"
                     placeholder="Como aparece na conta bancária">
            </div>
          </div>
        </div>

        <!-- Formulário Cartão -->
        <div *ngIf="billingForm.preferredPaymentMethod === 2">
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label">Nome no Cartão</label>
              <input type="text" class="form-control" [(ngModel)]="billingForm.cardHolderName"
                     placeholder="NOME COMO NO CARTÃO">
            </div>
            <div class="col-12">
              <label class="form-label">Número do Cartão</label>
              <div class="card-num-wrap">
                <input type="text" class="form-control" [(ngModel)]="cardNumberDisplay"
                       placeholder="0000 0000 0000 0000" maxlength="19"
                       (input)="formatCard($event)">
                <span class="card-brand-tag" *ngIf="billingForm.cardBrand">
                  {{ billingForm.cardBrand }}
                </span>
              </div>
            </div>
            <div class="col-6">
              <label class="form-label">Validade</label>
              <input type="text" class="form-control" [(ngModel)]="cardExpiry"
                     placeholder="MM/AA" maxlength="5" (input)="formatExpiry($event)">
            </div>
            <div class="col-6">
              <label class="form-label">CVV</label>
              <input type="password" class="form-control" placeholder="•••" maxlength="4">
            </div>
          </div>
          <div class="alert-info-box mt-3">
            <i class="bi bi-shield-lock-fill"></i>
            Dados protegidos por SSL. O número do cartão nunca é armazenado em nossos servidores.
          </div>
        </div>

        <div class="skip-billing mt-3 text-center">
          <small class="text-muted">
            Pode pular agora e configurar depois em
            <a href="javascript:void(0)" (click)="navigate('/professionals')">Profissionais</a>.
          </small>
        </div>
      </div>

    </div>

    <!-- Footer -->
    <div class="modal-box-footer">
      <button class="btn btn-secondary" (click)="closeModal()">Cancelar</button>
      <div class="d-flex gap-2">
        <button class="btn btn-outline-primary" *ngIf="modalTab === 'dados'"
                (click)="modalTab = 'pagamento'">
          Configurar Pagamento →
        </button>
        <button class="btn btn-primary" (click)="saveProf()" [disabled]="savingProf">
          <span *ngIf="savingProf" class="spinner-border spinner-border-sm me-2"></span>
          Cadastrar Profissional
        </button>
      </div>
    </div>

  </div>
</div>
